import { IconButton, Spinner, Tooltip, Typography, Chip, Input, Button } from '@material-tailwind/react'
import { FiRefreshCw } from 'react-icons/fi'

export function HeaderMobile({
  loading, rowsCount, query, setQuery,
  masterRef, allSelected, someSelected, onMasterToggle,
  onRefresh, onApproveSelected, onRejectSelected
}) {
  return (
    <div className="flex sm:hidden flex-col gap-3">
      <div className="flex items-center gap-3">
        <Tooltip content="Actualizar">
          <IconButton variant="text" onClick={onRefresh} title="Actualizar">
            {loading ? <Spinner className="h-4 w-4" /> : <FiRefreshCw />}
          </IconButton>
        </Tooltip>

        <Tooltip content={allSelected || someSelected ? 'Limpiar selección' : 'Seleccionar todo'}>
          <input
            ref={masterRef}
            type="checkbox"
            checked={allSelected}
            onChange={onMasterToggle}
            className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-0 cursor-pointer"
            aria-label="Seleccionar todo"
          />
        </Tooltip>

        <Typography variant="small" className="text-gray-600">Pendientes por aprobar</Typography>
        <Chip value={`${rowsCount} invitación(es)`} color="blue-gray" size="sm" className="rounded-full" />
      </div>

      <Input label="Buscar" value={query} onChange={(e) => setQuery(e.target.value)} crossOrigin="" />

      <div className="grid grid-cols-2 gap-2">
        <Button onClick={onApproveSelected} disabled={!allSelected && !someSelected} className="w-full">
          Aprobar seleccionados
        </Button>
        <Button variant="outlined" color="red" onClick={onRejectSelected} disabled={!allSelected && !someSelected} className="w-full">
          Rechazar seleccionados
        </Button>
      </div>
    </div>
  )
}